const routes = {
  root: '/adaptive-learning-content',
}

export default routes
